import { useState } from 'react'
import { useInput } from 'react-admin'
import { HexColorPicker } from 'react-colorful'

export const ColorPIckerInput = ({ source, validate, defaultValue, helperText, ...rest }) => {
  const {
    field,
    fieldState: { error },
  } = useInput({
    defaultValue,
    source,
    validate,
    ...rest,
  })

  const [color, setColor] = useState(field.value)

  const handleColorChange = (newColor) => {
    setColor(newColor)
    field.onChange(newColor)
  }

  return (
    <div>
      <HexColorPicker color={color} onChange={handleColorChange} />
      <input
        type='text'
        value={color}
        onChange={(e) => handleColorChange(e.target.value)}
        style={{
          width: '100%',
          padding: '5px 10px',
          marginTop: '10px',
          border: '1px solid #d9d9d9',
          borderRadius: '4px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          outline: 'none',
          fontSize: '14px',
          fontFamily: 'inherit',
          boxSizing: 'border-box',
          transition: 'box-shadow 0.2s',
        }}
        onFocus={() => {
          this.style.boxShadow = '0 2px 4px rgba(0, 128, 255, 0.2)'
        }}
        onBlur={() => {
          this.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)'
        }}
      />
      {(error?.message || helperText) && <span>{error?.message || helperText}</span>}
    </div>
  )
}
